import { FC, PropsWithChildren } from 'react';

type Props = {
	className?: string;
};

const PhilippinesFlagIcon: FC<PropsWithChildren<Props>> = ({ className }) => {
	return (
		<svg
			width='20'
			height='14'
			viewBox='0 0 20 14'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			className={`${className}`}>
			<rect
				x='0.25'
				y='0.25'
				width='19.5'
				height='13.5'
				rx='1.75'
				fill='white'
				stroke='#F5F5F5'
				strokeWidth='0.5'
			/>
			<mask
				id='mask0_2332_15723'
				style={{ maskType: 'luminance' }}
				maskUnits='userSpaceOnUse'
				x='0'
				y='0'
				width='20'
				height='14'>
				<rect
					x='0.25'
					y='0.25'
					width='19.5'
					height='13.5'
					rx='1.75'
					fill='white'
					stroke='white'
					strokeWidth='0.5'
				/>
			</mask>
			<g mask='url(#mask0_2332_15723)'>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0 14H20V6.53333H8.88889L9.52381 6.99999L0 14Z'
					fill='#DD1C34'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M20 6.53333H8.88889L0 0H20V6.53333Z'
					fill='#0D4BC3'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M1.42932 2.80003C1.69231 2.80003 1.90551 2.5911 1.90551 2.33337C1.90551 2.07563 1.69231 1.8667 1.42932 1.8667C1.16632 1.8667 0.953125 2.07563 0.953125 2.33337C0.953125 2.5911 1.16632 2.80003 1.42932 2.80003ZM7.1436 7.4667C7.40659 7.4667 7.61979 7.25776 7.61979 7.00003C7.61979 6.7423 7.40659 6.53337 7.1436 6.53337C6.88061 6.53337 6.66741 6.7423 6.66741 7.00003C6.66741 7.25776 6.88061 7.4667 7.1436 7.4667ZM1.90551 11.6667C1.90551 11.9244 1.69231 12.1334 1.42932 12.1334C1.16632 12.1334 0.953125 11.9244 0.953125 11.6667C0.953125 11.409 1.16632 11.2 1.42932 11.2C1.69231 11.2 1.90551 11.409 1.90551 11.6667ZM3.23794 7.92867L2.42293 9.15575L2.73202 7.72325C2.68228 7.68344 2.63673 7.63879 2.5961 7.59005L1.13436 7.89296L2.38649 7.09425C2.38332 7.06326 2.3817 7.03183 2.3817 7.00003C2.3817 6.96823 2.38332 6.9368 2.38649 6.90582L1.13436 6.1071L2.5961 6.41002C2.63673 6.36127 2.68228 6.31663 2.73202 6.27681L2.42293 4.84431L3.23794 6.0714C3.26956 6.06829 3.30163 6.0667 3.33408 6.0667C3.36653 6.0667 3.3986 6.06829 3.43021 6.0714L4.24523 4.84431L3.93614 6.27681C3.98587 6.31663 4.03143 6.36127 4.07206 6.41002L5.53379 6.1071L4.28167 6.90582C4.28484 6.9368 4.28646 6.96823 4.28646 7.00003C4.28646 7.03183 4.28484 7.06326 4.28167 7.09425L5.53379 7.89296L4.07206 7.59005C4.03143 7.63879 3.98587 7.68344 3.93614 7.72325L4.24523 9.15575L3.43021 7.92867C3.3986 7.93178 3.36653 7.93337 3.33408 7.93337C3.30163 7.93337 3.26956 7.93178 3.23794 7.92867Z'
					fill='#FDD64D'
				/>
			</g>
		</svg>
	);
};

export default PhilippinesFlagIcon;
